var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStatsModelTemplate = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.379 1.5C17.7768 1.50008 18.1583 1.65818 18.4395 1.9395L23.5605 7.0605C23.8418 7.34174 23.9999 7.72321 24 8.121V19.5C24 21.1569 22.6569 22.5 21 22.5H3C1.34315 22.5 0 21.1569 0 19.5V4.5C0 2.84315 1.34315 1.5 3 1.5H17.379ZM21.879 7.5L18 3.621V7.5H21.879ZM22.5 19.5C22.5 20.3284 21.8284 21 21 21H3C2.17157 21 1.5 20.3284 1.5 19.5V4.5C1.5 3.67157 2.17157 3 3 3H16.5V7.5C16.5 8.32843 17.1716 9 18 9H22.5V19.5ZM12.7683 6H4.5V6.31858L8.7439 12.2301L4.5 17.6814V18H13.0285L13.5 14.3717L13.1911 14.292C12.9905 15.1357 12.6897 15.6903 12.2886 15.9558C11.8875 16.2212 11.3076 16.354 10.5488 16.354H6.76829L10.5894 11.4425L7.23171 6.75221H10.5894C11.1423 6.75221 11.5461 6.82301 11.8008 6.9646C12.0556 7.10619 12.2561 7.33628 12.4024 7.65487C12.5488 7.96755 12.6409 8.42183 12.6789 9.0177H12.9878L12.7683 6Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStatsModelTemplate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/stats-model-template.112b7cc65a3a2b00bfdc1a19e9f81e3e.svg";